
export {Autocomplete,
Item} from '@clayui/autocomplete';
import __x__ from '@clayui/autocomplete';export default __x__;